import React from 'react';

interface KeywordTagProps {
  keywords: string[];
  isCard?: boolean;
}

const KeywordTag: React.FC<KeywordTagProps> = ({ keywords, isCard = false }) => {
  // Limit the number of tags displayed
  const visibleTags = !isCard ?  keywords.slice(0, 5) : keywords;
  const remainingCount = isCard ? keywords.length - visibleTags.length : keywords.length - visibleTags.length;

  return (
    <div className="flex flex-wrap gap-2">
      {visibleTags.map((keyword, index) => (
        <div
          key={index}
          className="px-4 py-2 rounded-xl border border-[#ecedf5] dark:border-gray-700 flex items-center justify-center text-center"
        >
          <div className="text-start text-[#414c5d] dark:text-gray-200 text-sm font-normal leading-tight">
            {keyword}
          </div>
        </div>
      ))}

      {/* Add a "+X more" tag if there are more than 5 keywords */}
      {remainingCount > 0 && (
        <div
          className="px-4 py-2 rounded-xl border border-[#ecedf5] dark:border-gray-700 flex items-center justify-center text-center bg-[#f5f5f5] dark:bg-gray-800"
        >
          <div className="text-start text-[#414c5d] dark:text-gray-200 text-sm font-normal leading-tight">
            +{remainingCount} more
          </div>
        </div>
      )}
    </div>
  );
};

export default KeywordTag;
